// @flow
import * as React from 'react';
import PropTypes from 'prop-types';
import { Box, Text } from 'gestalt';

type Props = {|
  color?: 'darkGray' | 'orange' | 'red',
  text: string,
|};

export default function Toast(props: Props) {
  const { color = 'darkGray', text } = props;

  // Toasts as Guides
  const contents = (
    <Box xs={{ display: 'flex' }} justifyContent="center" alignItems="center">
      <Text bold color="white" size="lg" align="center">
        {text}
      </Text>
    </Box>
  );

  return (
    <Box marginBottom={3} paddingX={4} maxWidth={376} width="100vw">
      <Box color={color} fit paddingX={8} paddingY={5} shape="pill">
        {contents}
      </Box>
    </Box>
  );
}

Toast.propTypes = {
  color: PropTypes.oneOf(['darkGray', 'orange', 'red']),
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
};
